import React, { useEffect, useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/16x16/ArrowLeft';
import DialogPopup from '../../../../Popup/DialogPopup';
import Input from '../../../../Input';
import { FooterButton } from '../../../../Popup/ModalDialog';
import { getFolderNameValidationErrorMessage } from '../../../../utils/isValidFolderName';
import s from './NewCollectionPopup.scss';
var NewCollectionPopup = function (_a) {
    var className = _a.className, folderNameBlacklist = _a.folderNameBlacklist, collectibleDeviation = _a.collectibleDeviation, createCollection = _a.createCollection, isSaving = _a.isSaving, onClose = _a.onClose;
    var t = useTranslation().t;
    var _b = useState(''), title = _b[0], setTitle = _b[1];
    var _c = useState(false), submitted = _c[0], setSubmitted = _c[1];
    var errorMessage = title
        ? getFolderNameValidationErrorMessage(title, t, folderNameBlacklist, false)
        : undefined;
    var onSubmit = function () {
        createCollection(title, collectibleDeviation.deviationId);
        setSubmitted(true);
    };
    useEffect(function () {
        if (submitted && !isSaving) {
            onClose();
        }
    }, [submitted, isSaving, onClose]);
    return (React.createElement(DialogPopup, { title: t('newCollectionPopup.title'), popoverClassName: c(s['root'], className), footer: React.createElement(FooterButton, { onClick: onSubmit, size: "small", fullWidth: false, disabled: !title || errorMessage !== undefined, loading: isSaving }, t('newCollectionPopup.button.primary')), footerExtras: React.createElement(TextButton, { size: "medium", variant: "main", onClick: onClose, disabled: isSaving, icon: ArrowLeft }, t('newCollectionPopup.button.back')), withScrollableContentWrapper: false, onClose: onClose },
        React.createElement("div", { className: s['content-wrapper'] },
            React.createElement(Input, { autoFocus: true, label: t('newCollectionPopup.input.label'), value: title, errorMessage: errorMessage, onChange: function (value) { return setTitle(value); }, readOnly: isSaving, onEnter: onSubmit }))));
};
NewCollectionPopup.displayName = 'NewCollectionPopup';
export default NewCollectionPopup;
//# sourceMappingURL=NewCollectionPopup.js.map